import { formatCurrency } from "../../../../Utils/formatters";

export const DEMO_CARD_INVOICES = [
  {
    id: "inv-current",
    month: "Jun/2026",
    closingDate: "08/06/2026",
    dueDate: "15/06/2026",
    amountCents: 128040,
    status: "open",
    minimumCents: 12804,
  },
  {
    id: "inv-2",
    month: "Mai/2026",
    closingDate: "08/05/2026",
    dueDate: "15/05/2026",
    amountCents: 245000,
    status: "paid",
    minimumCents: 24500,
  },
  {
    id: "inv-3",
    month: "Abr/2026",
    closingDate: "08/04/2026",
    dueDate: "15/04/2026",
    amountCents: 189900,
    status: "paid",
    minimumCents: 18990,
  },
];

const STATUS_LABEL = {
  open: "Em aberto",
  paid: "Paga",
  overdue: "Vencida",
};

export const CardInvoicesSection = ({
  invoices = DEMO_CARD_INVOICES,
  onPayInvoice,
  embedded = false,
}) => {
  const list = (
    <ul className="cartoes-invoices-list">
      {invoices.map((invoice) => {
        const isOpen = invoice.status === "open";

        return (
          <li key={invoice.id} className="cartoes-invoices-list__item">
            <div className="cartoes-invoices-list__main">
              <div>
                <p className="cartoes-invoices-list__month">{invoice.month}</p>
                <p className="cartoes-invoices-list__meta">
                  Fechamento {invoice.closingDate} · Vencimento {invoice.dueDate}
                </p>
              </div>
              <div className="cartoes-invoices-list__amounts">
                <p className="cartoes-invoices-list__total">
                  {formatCurrency(invoice.amountCents)}
                </p>
                {isOpen && (
                  <p className="cartoes-invoices-list__minimum">
                    Mínimo {formatCurrency(invoice.minimumCents)}
                  </p>
                )}
              </div>
            </div>

            <div className="cartoes-invoices-list__footer">
              <span
                className={`cartoes-invoices-list__status cartoes-invoices-list__status--${invoice.status}`}
              >
                {STATUS_LABEL[invoice.status] || invoice.status}
              </span>
              {isOpen ? (
                <button
                  type="button"
                  className="cartoes-invoices-list__action"
                  onClick={() => onPayInvoice?.(invoice)}
                >
                  Pagar fatura
                </button>
              ) : (
                <button
                  type="button"
                  className="cartoes-invoices-list__action cartoes-invoices-list__action--ghost"
                >
                  Ver detalhes
                </button>
              )}
            </div>
          </li>
        );
      })}
    </ul>
  );

  if (embedded) return list;

  return (
    <section className="app-card overflow-hidden">
      <div className="cartoes-section-header">
        <div>
          <h3>Faturas</h3>
          <p className="mt-0.5 text-xs font-normal text-gray-500">
            Histórico e fatura em aberto do cartão de crédito
          </p>
        </div>
      </div>
      {list}
    </section>
  );
};
